module.exports = __webpack_public_path__ + "img/about-circle.b331d850.png";